<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
      fill="#C2C6CD"
    />
    <rect
      x="13"
      y="24"
      width="16"
      height="16"
      transform="rotate(-45 13 24)"
      fill="white"
    />
  </svg>
</template>
